import { onCleanup, onMount } from "solid-js";

export default function clickOutside(el: Element, accessor: () => any) {
  const onClick = (e) => {
    if (e == undefined || e.target == undefined) {
      return;
    }
    if (el.contains(e.target)) {
      return;
    }
    accessor()?.();
  };
  onMount(() => {
    document.body.removeEventListener("click", onClick);
    document.body.addEventListener("click", onClick);
  });
  onCleanup(() => document.body.removeEventListener("click", onClick));
}
